import styled from 'styled-components'

export const StyledNewListView = styled.div``

export const CTAList = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
`
